import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const faqs = [{
  q: '¿Cómo recibo el material?',
  a: 'Después del pago recibirás acceso inmediato al contenido digital completo.'
}, {
  q: '¿Necesito experiencia en cocina?',
  a: 'No. Las recetas y planificaciones son simples y fáciles de aplicar.'
}, {
  q: '¿El contenido sirve para niños y adultos?',
  a: 'Sí. El sistema incluye recomendaciones para todas las edades.'
}, {
  q: '¿Las recetas son 100% sin gluten?',
  a: 'Sí. Todo el contenido está pensado para personas celíacas.'
}, {
  q: '¿Esto reemplaza consultas médicas?',
  a: 'No. Siempre es importante mantener controles médicos y nutricionales adecuados.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-white" data-id="element-50">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-51">
        <div className="text-center mb-16" data-id="element-52">
          <FadeIn data-id="element-53">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-950" data-id="element-54">
              PREGUNTAS FRECUENTES
            </h2>
          </FadeIn>
        </div>

        <div className="space-y-4" data-id="element-55">
          {faqs.map((faq, idx) => {
          const isOpen = openIndex === idx;
          return <FadeIn key={idx} delay={idx * 0.1} data-id="element-56">
                <div className="border border-brand-100 rounded-2xl overflow-hidden bg-cream-50" data-id="element-57">
                  <button onClick={() => setOpenIndex(isOpen ? null : idx)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-58">
                    <span className="font-bold text-brand-950 text-lg pr-8" data-id="element-59">
                      {faq.q}
                    </span>
                    <ChevronDown className={`w-6 h-6 text-brand-500 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-60" />
                  </button>
                  <AnimatePresence data-id="element-61">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: 'easeInOut'
                }} data-id="element-62">
                        <div className="px-6 pb-6 text-brand-700 leading-relaxed" data-id="element-63">
                          {faq.a}
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}